import React, {useEffect, useState} from "react";
import axios from "axios";
import CircularLoader from "@common/CircularLoader";
import {Row} from "antd";
import Question from "./Question";
import Card from "@common/Card";

const TrailQuestionResults = props => {
    const {step} = props;
    const [questions, setQuestions] = useState(null);
    const [questionResults, setQuestionResults] = useState({});

    useEffect(() => {
        if (!step) return;

        const controller = new AbortController();
        const loadQuestionResults = async () => {
            try {
                const url = `/web/ui/question/trail/results`;
                const {data} = await axios.get(url, {
                    params: {pathwayUserId: step.pathwayUserId, stepId: step.stepId},
                    signal: controller.signal,
                });
                setQuestions(data.questions);
                const resultMap = {};
                (data.questionResults || []).forEach(result => {
                    resultMap[result.questionId] = result;
                });
                setQuestionResults(resultMap);
            } catch (error) {
                if (axios.isCancel(error)) return;
                setQuestions([]);
            }
        };

        loadQuestionResults();

        return () => controller.abort();
    }, [step]);

    if (questions === null) return (
        <Row>
            <CircularLoader displayInElement={true}/>
        </Row>
    )

    return (
        <div className="flexColumn largeGap">
            {questions.map((question, index) => {
                const questionResult = questionResults[question.questionId];

                return (
                    <Card
                        key={`question${index+1}-result-${question.questionId}`}
                        variant={"outlined"}
                    >
                        <h4 id={`q-title-${index}`}>Question {index + 1}</h4>
                        <Question
                            aria-labelledby={`q-title-${index}`}
                            className={"margin-t--l"}
                            question={question}
                            isLoading={false}
                            readOnly={true}
                            result={questionResult}
                            displayAnswerOnResult={true}
                        />
                    </Card>
                )
            })}
        </div>
    )
}

export default TrailQuestionResults;